import { Component, Input } from '@angular/core';
import { ComponentBase, DeploymentContext } from '@Common';

@Component({
	selector: 'annulus',
	templateUrl: './annulus.component.html',
	styleUrls: ['./annulus.component.scss'],
	standalone: false,
})
export class AnnulusComponent extends ComponentBase {
	@Input()
	public color: string;
	@Input()
	public iconClass: string;
	@Input()
	public scale: string;
	@Input()
	public value: number;

	public constructor(dc: DeploymentContext) {
		super(dc);
	}

	public get positionClass(): string {
		return this.scale === 'large'
			? 'cf_annulus-icon-large'
			: 'cf_annulus-icon-small';
	}

	public get rotationClass(): string {
		const degrees = Math.floor(this.value * 360);
		const rotationPrefix =
			this.color === 'light' ? 'rotationLight' : 'rotationDark';
		return `${rotationPrefix}${degrees}`;
	}

	public get sizeRotationAndStrokeClasses(): string {
		return this.scale === 'large'
			? `cf_annulus-size-large ${this.rotationClass}`
			: `cf_annulus-size-small ${this.rotationClass}`;
	}
}
